module.exports = __webpack_public_path__ + "img/home-decor-1.decbdadf.jpg";